import debounce from 'lodash.debounce';
import React, {useEffect, useState} from 'react';

const useDirectionalScrollPositionEffect = (
  element: React.RefObject<HTMLDivElement>,
  cb: (scrollLeft: number) => void,
  direction: 'vertical' | 'horizontal' = 'horizontal',
) => {
  useEffect(() => {
    const updateScroll = debounce(
      (ev: Event) =>
        cb(
          ev.target
            ? (ev.target as HTMLDivElement)[
                direction === 'horizontal' ? 'scrollLeft' : 'scrollTop'
              ]
            : 0,
        ),
      30,
      {
        trailing: true,
        leading: true,
        maxWait: 70,
      },
    );

    if (element.current) {
      element.current.addEventListener('scroll', updateScroll, {
        passive: true,
      });
    }

    return () => {
      if (!element.current) {
        return;
      }
      element.current.removeEventListener('scroll', updateScroll);
    };
  }, [element.current, cb]);
};

export const useDirectionalScrollPosition = (
  element: React.RefObject<HTMLDivElement>,
  direction: 'vertical' | 'horizontal' = 'horizontal',
) => {
  const [scrollPosition, setScrollPosition] = useState(NaN);
  useDirectionalScrollPositionEffect(element, setScrollPosition, direction);

  return scrollPosition;
};
